import init from "./Modules/MapLibre.mjs";

init();
